// ponytail: คัดลอกจาก backend/utils/thaiId.js — เหตุผลและที่มาอยู่ในไฟล์นั้น
// แก้ที่ไหนต้องแก้ทั้งสองที่ ฝั่งนี้กันตอนกรอก ฝั่ง server กันคนที่เรียก API ตรง
export const isValidThaiId = (id) => {
  const d = String(id ?? '');
  if (!/^\d{13}$/.test(d)) return false;
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += Number(d[i]) * (13 - i);
  return (11 - (sum % 11)) % 10 === Number(d[12]);
};
